import React from 'react';
import { ModalBody } from 'reactstrap';
import { accentUtils, showDialog, t } from '../services/HelperService';
import { AccentDialog } from '../dialogs/AccentDialog';

export const showRecordInfo = (details) => {
    showDialog(<RecordInfoDlg details={details} />);
};

const normalizeDetailsArray = (details) => {
    if (accentUtils.isNull(details)) return [];
    if (Array.isArray(details)) return details;
    if (typeof details === 'object') return [details];
    return [{ value: details }];
};

const stringify = (v) => {
    if (accentUtils.isNull(v)) return "";
    if (typeof v === 'string') return v;
    try {
        return JSON.stringify(v, null, 2);
    } catch {
        return `${v}`;
    }
};

const formatFieldName = (name) => {
    if (accentUtils.isNull(name)) return "";

    return `${name}`
        .replaceAll("_", " ")
        .replace(/([a-z0-9])([A-Z])/g, "$1 $2")
        .replace(/\s+/g, " ")
        .trim();
};

const getFieldLabel = (entityRoot, fieldName) => {
    if (!accentUtils.isEmpty(entityRoot) && !accentUtils.isEmpty(fieldName)) {
        const key = `application_strings.entities.${entityRoot}.${fieldName}`;
        const translated = t(key);
        if (translated !== key) return translated;
    }

    return formatFieldName(fieldName);
};

const getRows = (details) => {
    if (accentUtils.isNull(details)) return [];

    if (typeof details !== "object" || Array.isArray(details)) {
        return [{ label: "Value", value: details }];
    }

    const fields = details?.fields;
    if (!accentUtils.isNull(fields) && typeof fields === "object" && !Array.isArray(fields)) {
        const entityRoot = details?.entityRoot;
        return Object.keys(fields).map(fieldName => ({
            label: getFieldLabel(entityRoot, fieldName),
            value: fields[fieldName]
        }));
    }

    return Object.keys(details)
        .filter(k => k !== "title")
        .map(k => ({ label: formatFieldName(k), value: details[k] }));
};

const RecordInfoDlg = ({ onClose, details }) => {

    const items = normalizeDetailsArray(details);
    const first = items[0] ?? {};
    const rows = getRows(first);

    return (
        <AccentDialog
            headerContent={t("application_strings.application.buttons.recordInfo")}
            onClose={onClose}
            relativeWidth={d => Math.min(760, d.width - 80)}
            relativeHeight={d => Math.min(560, d.height - 80)}
        >
            <ModalBody>
                <table className="table table-sm">
                    <tbody>
                        {rows.map((r, idx) => (
                            <tr key={idx}>
                                <th style={idx === 0 ? { width: 180 } : undefined}>{r.label}</th>
                                <td>{stringify(r.value)}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </ModalBody>
        </AccentDialog>
    );
};


